import {
  CanSelfScheduleVisit,
  CanSelfScheduleVisitVariables,
} from 'types/graphql'

import { TypedDocumentNode, useQuery } from '@cedarjs/web'

const CAN_SELF_SCHEDULE_VISIT: TypedDocumentNode<
  CanSelfScheduleVisit,
  CanSelfScheduleVisitVariables
> = gql`
  query CanSelfScheduleVisit {
    canSelfScheduleVisit
  }
`

export const useCanSelfScheduleVisit = () => {
  const { data, loading, error } = useQuery<CanSelfScheduleVisit>(
    CAN_SELF_SCHEDULE_VISIT
  )

  return {
    canSelfScheduleVisit: data?.canSelfScheduleVisit,
    loading,
    error,
  }
}
